import { render, staticRenderFns } from "./Pad.vue?vue&type=template&id=39100be0&"
import script from "./Pad.vue?vue&type=script&lang=js&"
export * from "./Pad.vue?vue&type=script&lang=js&"
import style0 from "./Pad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports